import { useEffect, useState } from "react";
import { IAccountFilter } from "../../Store/Accounts/types"
import { BoxButton } from "./Components/BoxButton";
import ButtonLightGray from "./Components/ButtonLightGray";
import ChipFactory from "./Components/chips/ChipFactory";
import DrawerMoreFilters from "./Components/drawer/DrawerMoreFilters";
import FilterTextField from "./Components/FilterTextField";
import { GridButton } from "./Components/grid/GridButton";
import GridContainer from "./Components/grid/GridContainer";
import { Grid } from "@mui/material";
import ButtonGradient from "./Components/ButtonGradient";

interface IAccountFilterProps {
    filter: IAccountFilter,
    onFilterApply: (filter: IAccountFilter) => void,
    setOpenCreateAccountDialog: (open: boolean) => void
}

const AccountsFilter: React.FC<IAccountFilterProps> = (props) => {
    const [accountFilter, setAccountFilter] = useState<IAccountFilter>(props.filter)
    const [regexValid, setRegexValid] = useState(true);
    const [openMoreFilters, setOpenMoreFilters] = useState<boolean>(false)

    useEffect(() => {
        setAccountFilter(props.filter)
    }, [props.filter]);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            onFilterApply(accountFilter)
        }   
    }

    const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setAccountFilter({...accountFilter, username: event.target.value})
        try {
            new RegExp(event.target.value);
        } catch(e) {
            setRegexValid(false)
            return;
        }
        setRegexValid(true)
    }

    const setFilterChip = (filter: IAccountFilter) => {
        props.onFilterApply(filter)
        setAccountFilter(filter)
    }

    const resetFilter = () => {
        setAccountFilter({})
        props.onFilterApply({})
    }

    const onFilterApply = (filter: IAccountFilter) => {
        setAccountFilter(filter)
        props.onFilterApply(filter);
        setOpenMoreFilters(false)
    }

    return (
        <>
            <GridContainer container style={{paddingTop: "0px"}}>
                <Grid item xs={12} md={6}>
                    <FilterTextField
                        style={{height: "100%"}}
                        variant='outlined'
                        spellCheck="false"
                        fullWidth
                        label="Regex"
                        size="small"
                        placeholder='Click to filter usernames'
                        value={accountFilter.username}
                        onChange={(event) => handleUsernameChange(event)}
                        error={!regexValid}
                        onClick={() => onFilterApply(accountFilter)}
                        onInputKeyDown={handleKeyDown}
                    />
                </Grid>
                <GridButton item xs={6} md={3}>
                    <BoxButton>
                        <ButtonLightGray
                            onClick={() => setOpenMoreFilters(true)}
                            variant='text'
                            color="primary"
                            style={{height: "100%"}}
                        >
                            More filters
                        </ButtonLightGray>
                    </BoxButton>
                </GridButton>
                <GridButton item xs={6} md={3}>
                    <BoxButton display="flex" justifyContent="flex-end">
                        <ButtonGradient
                            onClick={() => props.setOpenCreateAccountDialog(true)}
                            color="primary"
                            variant="contained"
                            style={{height: "100%"}}
                        >
                            Add account
                        </ButtonGradient>
                    </BoxButton>
                </GridButton>
                <ChipFactory
                    filter={props.filter}
                    setChip={setFilterChip}
                    clearFilter={resetFilter}
                />
            </GridContainer>
            <DrawerMoreFilters
                anchor='right'
                type="account"
                filter={accountFilter}
                setFilter={setAccountFilter}
                open={openMoreFilters}
                onClose={() => setOpenMoreFilters(false)}
                resetFilter={resetFilter}
                onFilterApply={onFilterApply}
            />
        </>
    )
}

export default AccountsFilter